/**
 * GC degli asset (API.md §3): gli asset che non compaiono più nel manifest corrente si cancellano
 * 24 ore dopo, oppure subito se lo spazio libero scende sotto il 10%.
 * Funzione pura: il chiamante persiste `unreferencedSince`.
 */
import { keyString, type AssetKey } from './asset-cache';

export const GC_GRACE_MS = 24 * 3600 * 1000;
export const LOW_DISK_RATIO = 0.10;

export interface GcInput {
  stored: AssetKey[];
  /** Chiavi (`id|sha256`) referenziate dal manifest in uso o dal manifest in attesa. */
  referenced: Set<string>;
  unreferencedSince: Record<string, number>;
  now: number;
  lowDisk: boolean;
}
export interface GcPlan {
  remove: AssetKey[];
  unreferencedSince: Record<string, number>;
}

export function planGc(input: GcInput): GcPlan {
  const next: Record<string, number> = {};
  const remove: AssetKey[] = [];
  for (const k of input.stored) {
    const ks = keyString(k);
    if (input.referenced.has(ks)) continue; // di nuovo referenziato: azzera il contatore
    const since = input.unreferencedSince[ks] ?? input.now;
    if (input.lowDisk || input.now - since >= GC_GRACE_MS) remove.push(k);
    else next[ks] = since;
  }
  return { remove, unreferencedSince: next };
}

export function isLowDisk(est: { usage: number; quota: number } | null): boolean {
  return est !== null && est.quota > 0 && (est.quota - est.usage) / est.quota < LOW_DISK_RATIO;
}
